import useSendVDPMegaEvent from '~/components/vdp/VehicleDetailsContainer/hooks/events/useSendVDPMegaEvent';

export default function PagesRouterDataHooks() {
  useSendVDPMegaEvent();

  return null;
}
